import { Heart } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Rsvp({ datos, seccion, acciones }) {
  const rsvp = datos.rsvp || {};

  return (
    <section className="cv-seccion cv-rsvp" aria-label={seccion.titulo}>
      <div className="cv-seccion-interior">
        <EncabezadoSeccion p="cv" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="cv-titulo-rsvp" />
        <Reveal delay={0.1}>
          {rsvp.mensaje && <p className="cv-rsvp-mensaje">{rsvp.mensaje}</p>}
          {rsvp.fechaLimite && <p className="cv-rsvp-limite">{rsvp.fechaLimite}</p>}
          <button
            type="button"
            className="cv-boton cv-boton--claro"
            onClick={() => acciones?.onConfirmarAsistencia?.()}
            data-testid="cv-boton-rsvp"
          >
            <Heart strokeWidth={1.5} />
            {rsvp.textoBoton || "Confirmar asistencia"}
          </button>
        </Reveal>
      </div>
    </section>
  );
}
